import { render, staticRenderFns } from "./Informe70Anios.vue?vue&type=template&id=4960321f&scoped=true"
import script from "./Informe70Anios.vue?vue&type=script&lang=js"
export * from "./Informe70Anios.vue?vue&type=script&lang=js"
import style0 from "./Informe70Anios.vue?vue&type=style&index=0&id=4960321f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960321f",
  null
  
)

export default component.exports